import { Grid } from '@agrotoken-tech/ui';

type GridProps = Parameters<typeof Grid>[0];
export const SectionGrid = ({ children, ...rest }: GridProps) => {
  return (
    <Grid templateColumns={{ md: 'repeat(2, 1fr)' }} gap={6} {...rest}>
      {children}
    </Grid>
  );
};
